import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import PropTypes from "prop-types";
import { Flex, RadioButton, Fieldset, Skeleton } from "@base-ui";
import { extendedSystemStylesProps } from "@mixins";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var styledSystemKeys = ["space", "layout", "flexbox"];
var RadioButtonFieldset = function RadioButtonFieldset(props) {
  var id = props.id,
    legend = props.legend,
    hideLegend = props.hideLegend,
    options = props.options,
    updateSelected = props.updateSelected,
    name = props.name,
    icon = props.icon,
    className = props.className,
    ellipse = props.ellipse,
    loading = props.loading;
  if (loading) return /*#__PURE__*/_jsx(Fieldset, _objectSpread(_objectSpread({
    legend: legend,
    hideLegend: hideLegend
  }, extendedSystemStylesProps(styledSystemKeys, props)), {}, {
    className: className,
    icon: icon,
    children: Array(4).fill(0).map(function (_, idx) {
      return /*#__PURE__*/_jsxs(Flex.Row, {
        height: "44px",
        children: [/*#__PURE__*/_jsx(Skeleton.Circle, {
          width: "24px",
          height: "24px",
          m: "auto 0"
        }), /*#__PURE__*/_jsx(Skeleton.Box, {
          height: "24px",
          width: "calc(100% - 32px)",
          m: "auto 0 auto 10px"
        })]
      }, idx);
    })
  }));
  var radiobuttons = options.map(function (option) {
    return /*#__PURE__*/_jsx(RadioButton, {
      id: "".concat(id, "-radio-").concat(option.id),
      label: option.label,
      accessibleLabel: option.accessibleLabel,
      name: name,
      checked: option.checked,
      onChange: function onChange() {
        return updateSelected(option.id);
      },
      ellipse: ellipse
    }, option.id);
  });
  return /*#__PURE__*/_jsx(Fieldset, _objectSpread(_objectSpread({
    legend: legend,
    hideLegend: hideLegend
  }, extendedSystemStylesProps(styledSystemKeys, props)), {}, {
    className: className,
    icon: icon,
    children: /*#__PURE__*/_jsx(Flex.Column, {
      width: "inherit",
      children: radiobuttons
    })
  }));
};
RadioButtonFieldset.propTypes = {
  id: PropTypes.string.isRequired,
  legend: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  updateSelected: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  hideLegend: PropTypes.oneOf([true, false]),
  icon: PropTypes.string,
  loading: PropTypes.oneOf([true, false]),
  ellipse: PropTypes.oneOf([true, false]),
  className: PropTypes.string
};
RadioButtonFieldset.defaultProps = {
  hideLegend: false,
  ellipse: false,
  loading: false
};
export default RadioButtonFieldset;